// Keep whitespace and template placeholders intact when highlighting message edits.
const tokens = (text) => String(text ?? "").match(/\s+|[^\s]+/g) || [];

export default function messageDiff(before, after) {
  const old = tokens(before), next = tokens(after), changes = [];
  const append = (type, text) => {
    if (!text) return;
    const last = changes[changes.length - 1];
    if (last?.type === type) last.text += text;
    else changes.push({ type, text });
  };
  let start = 0, oldEnd = old.length, nextEnd = next.length;
  while (start < oldEnd && start < nextEnd && old[start] === next[start]) start++;
  while (oldEnd > start && nextEnd > start && old[oldEnd - 1] === next[nextEnd - 1]) { oldEnd--; nextEnd--; }
  append("same", old.slice(0, start).join(""));
  const oldCount = oldEnd - start, nextCount = nextEnd - start;
  // Bound the comparison work for unusually large pasted messages.
  if ((oldCount + 1) * (nextCount + 1) > 250000) {
    append("removed", old.slice(start, oldEnd).join(""));
    append("added", next.slice(start, nextEnd).join(""));
  } else {
    const width = nextCount + 1;
    const lengths = new Uint32Array((oldCount + 1) * width);
    for (let i = oldCount - 1; i >= 0; i--) {
      for (let j = nextCount - 1; j >= 0; j--) {
        lengths[i * width + j] = old[start + i] === next[start + j]
          ? lengths[(i + 1) * width + j + 1] + 1
          : Math.max(lengths[(i + 1) * width + j], lengths[i * width + j + 1]);
      }
    }
    let i = 0, j = 0;
    while (i < oldCount || j < nextCount) {
      if (i < oldCount && j < nextCount && old[start + i] === next[start + j]) {
        append("same", old[start + i]); i++; j++;
      } else if (i < oldCount && (j === nextCount || lengths[(i + 1) * width + j] >= lengths[i * width + j + 1])) {
        append("removed", old[start + i++]);
      } else append("added", next[start + j++]);
    }
  }
  append("same", old.slice(oldEnd).join(""));
  return changes;
}
